var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stats-container" },
    [
      _vm._l(_vm.stats, function(stat, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "b-tooltip",
                rawName: "v-b-tooltip.hover",
                modifiers: { hover: true }
              }
            ],
            key: index,
            staticClass: "stat",
            attrs: { title: stat.tooltip }
          },
          [
            _vm.$route.path === "/transactions"
              ? _c("div", { staticClass: "data" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(stat.data.slice(0, 2)) +
                      " " +
                      _vm._s((+stat.data.slice(2)).toLocaleString("en-US")) +
                      "\n            "
                  )
                ])
              : _c("div", { staticClass: "data" }, [
                  _vm._v(
                    "\n                " + _vm._s(stat.data) + "\n            "
                  )
                ]),
            _vm._v(" "),
            _c("div", { staticClass: "label" }, [
              _vm._v(
                "\n                " + _vm._s(stat.label) + "\n            "
              )
            ])
          ]
        )
      }),
      _vm._v(" "),
      _vm.$route.path === "/contacts"
        ? _c(
            "div",
            {
              staticClass:
                "d-flex flex-grow-1 justify-content-end align-items-center"
            },
            [
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "primary-btn contact px-4",
                    on: { click: _vm.emailAll }
                  },
                  [_vm._v("Email All Contacts")]
                )
              ])
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73798239", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73798239","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Stats.vue
// module id = null
// module chunks = 